<!-- navbar -->

<app-header
  brand=""
  brandlink=""
>

</app-header>



<div
  class="container-fluid  overflow-auto"
  id="scrollingTag"
>
  <div class="row"></div>
  <div class="row  ">
    <div class="col p-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div
  style="position: fixed; bottom: 5px; left: 50%; transform: translateX(-50%); display: flex; gap: 16px; z-index: 9999;"
>
  <a
    href="https://www.profil-m.de/ac-suite-datenschutz/"
    target="_blank"
    rel="noopener noreferrer"
    style="color: #666; font-size: 12px; text-decoration: none;"
    i18n="@@linkPrivacyPolicy"
  >Datenschutzhinweise</a>
  <a
    href="https://www.profil-m.de/impressum/"
    target="_blank"
    rel="noopener noreferrer"
    style="color: #666; font-size: 12px; text-decoration: none;"
    i18n="@@linkImprint"
  >Impressum</a>
</div>